'use client'

import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'
import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import ShopMarketplaceCarousel from '@/components/shopMarketplaceCarousel/ShopMarketplaceCarousel'
import { FeatureFlags } from '@/helpers/featureFlags'

interface NewSellerCarouselProps {
  endpoint: string
}

export default function NewSellerCarousel({
  endpoint,
}: NewSellerCarouselProps) {
  // Every listing here is from a new seller by construction (the search filter), so the tag
  // needs no storefront lookup; it follows the same experiment flag as the ALP card's tag.
  const showNewSellerTag =
    useFlag(FeatureFlags.NEW_SELLER_ALP_LABEL) === 'treatment'
  return (
    <ShopMarketplaceCarousel
      title={<FormattedMessage id="Common.Carousel.newSellersTitle" />}
      carousel_name="new-sellers"
      viewMoreUrl="/all-auctions?newSeller=true"
      endpoint={endpoint}
      isNewSellerListing={showNewSellerTag}
    />
  )
}
